/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketssettingshintorganizer3Inputs */

const en_ticketssettingshintorganizer3 = /** @type {(inputs: Ticketssettingshintorganizer3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You pay the ticket fee`)
};

const de_ticketssettingshintorganizer3 = /** @type {(inputs: Ticketssettingshintorganizer3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ticketgebühr zahlst du`)
};

/**
* | output |
* | --- |
* | "You pay the ticket fee" |
*
* @param {Ticketssettingshintorganizer3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketssettingshintorganizer3 = /** @type {((inputs?: Ticketssettingshintorganizer3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketssettingshintorganizer3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketssettingshintorganizer3(inputs)
	return de_ticketssettingshintorganizer3(inputs)
});
export { ticketssettingshintorganizer3 as "ticketsSettingsHintOrganizer" }